export const colors = {
  "black": "#0b0b0b",
  "white": "#ffffff",
  "transparent": "rgba(0, 0, 0, 0)",
  "current": "currentColor",
  "ruby": {
    "25": "oklch(97.91% 0.016828 345.77)",
    "50": "oklch(94.87% 0.03706 357.98)",
    "100": "oklch(92.3% 0.058527 359.82)",
    "200": "oklch(88.88% 0.08261 0.87)",
    "300": "oklch(76.93% 0.17328 6.74)",
    "400": "oklch(67.87% 0.271827 9.7)",
    "500": "oklch(0.5774 0.2542 13.92)",
    "600": "oklch(50.54% 0.224731 15.32)",
    "700": "oklch(39.27% 0.163673 11.31)",
    "800": "oklch(32.51% 0.131328 10.9)",
    "900": "oklch(26.52% 0.091901 10.42)",
    "950": "oklch(22.51% 0.062174 9.15)",
    "975": "oklch(20.44% 0.049631 7.18)"
  },
  "red": {
    "25": "oklch(97.64% 0.013104 18.21)",
    "50": "oklch(95.85% 0.033476 19.61)",
    "100": "oklch(92.07% 0.052583 22.2)",
    "200": "oklch(88.78% 0.18396 22.45)",
    "300": "oklch(79.63% 0.196584 25.01)",
    "400": "oklch(67.48% 0.23131 26.42)",
    "500": "oklch(54.85% 0.263693 23.89)",
    "600": "oklch(50.19% 0.217069 25.07)",
    "700": "oklch(38.96% 0.158571 23.32)",
    "800": "oklch(32.8% 0.113062 22.1)",
    "900": "oklch(26.15% 0.081453 23.41)",
    "950": "oklch(22.44% 0.06865 19.83)",
    "975": "oklch(20.82% 0.051842 18.39)"
  },
  "orange": {
    "25": "oklch(97.44% 0.020575 47.9)",
    "50": "oklch(94.75% 0.038797 58.68)",
    "100": "oklch(92.42% 0.056762 52.67)",
    "200": "oklch(87.62% 0.097004 53.74)",
    "300": "oklch(77.25% 0.169949 44.38)",
    "400": "oklch(0.6613 0.2402 40.84)",
    "500": "oklch(57.09% 0.229215 34.25)",
    "600": "oklch(49.45% 0.189216 36.33)",
    "700": "oklch(38.56% 0.128961 38.36)",
    "800": "oklch(32.24% 0.095074 34.04)",
    "900": "oklch(25.85% 0.066069 44.16)",
    "950": "oklch(22.61% 0.057063 56.67)",
    "975": "oklch(21.2% 0.039022 51.61)"
  },
  "yellow": {
    "25": "oklch(97.62% 0.030516 81.85)",
    "50": "oklch(95.37% 0.057217 88.2)",
    "100": "oklch(92.17% 0.109234 86.71)",
    "200": "oklch(87.81% 0.152987 82.38)",
    "300": "oklch(77.05% 0.168281 71.66)",
    "400": "oklch(63.59% 0.161108 63.69)",
    "500": "oklch(54.56% 0.147736 58.47)",
    "600": "oklch(47.24% 0.115166 55.24)",
    "700": "oklch(37.21% 0.08946 64.18)",
    "800": "oklch(32.41% 0.070588 62.59)",
    "900": "oklch(25.2% 0.054594 70.03)",
    "950": "oklch(22.4% 0.043494 68.82)",
    "975": "oklch(20.7% 0.026151 70.36)"
  },
  "gold": {
    "25": "oklch(97.89% 0.044729 101.99)",
    "50": "oklch(95.09% 0.074633 98.14)",
    "100": "oklch(91.95% 0.132908 98.67)",
    "200": "oklch(87.64% 0.210504 100.12)",
    "300": "oklch(76.53% 0.181918 95.67)",
    "400": "oklch(62.11% 0.147068 93.63)",
    "500": "oklch(53.25% 0.120405 92.08)",
    "600": "oklch(46.05% 0.104091 93.97)",
    "700": "oklch(36.48% 0.083058 100.25)",
    "800": "oklch(31.63% 0.057549 96.28)",
    "900": "oklch(25.55% 0.094829 103.76)",
    "950": "oklch(21.92% 0.072992 110.37)",
    "975": "oklch(20.1% 0.0522 105.14)"
  },
  "lime": {
    "25": "oklch(97.77% 0.02829 135.15)",
    "50": "oklch(94.58% 0.074726 129.77)",
    "100": "oklch(91.28% 0.143573 132.6)",
    "200": "oklch(84.7% 0.23173 134.38)",
    "300": "oklch(73.64% 0.245679 137.17)",
    "400": "oklch(0.6053 0.2127 141.66)",
    "500": "oklch(0.51 0.2048 139.94)",
    "600": "oklch(0.4433 0.1591 140.38)",
    "700": "oklch(34.83% 0.119208 138.2)",
    "800": "oklch(30.67% 0.092568 140.03)",
    "900": "oklch(23.72% 0.067919 137.47)",
    "950": "oklch(21.77% 0.051043 135.18)",
    "975": "oklch(19.29% 0.056729 133.49)"
  },
  "green": {
    "25": "oklch(97.74% 0.031295 164.86)",
    "50": "oklch(94.5% 0.07041 158.65)",
    "100": "oklch(92.29% 0.105357 154.1)",
    "200": "oklch(84% 0.202524 151.64)",
    "300": "oklch(73.33% 0.211507 153.2)",
    "400": "oklch(60.42% 0.209442 152.72)",
    "500": "oklch(51.08% 0.174054 154.66)",
    "600": "oklch(44.17% 0.149548 155.18)",
    "700": "oklch(34.99% 0.112138 157.16)",
    "800": "oklch(30.25% 0.08462 158.9)",
    "900": "oklch(23.85% 0.055959 162.6)",
    "950": "oklch(21.83% 0.040438 159.15)",
    "975": "oklch(19.73% 0.036012 168.91)"
  },
  "jade": {
    "25": "oklch(97.62% 0.030504 185.16)",
    "50": "oklch(94.73% 0.060719 172.36)",
    "100": "oklch(90.35% 0.114692 171.57)",
    "200": "oklch(83.78% 0.160796 171.72)",
    "300": "oklch(73.06% 0.195687 168.59)",
    "400": "oklch(60.55% 0.165 169.23)",
    "500": "oklch(0.5079 0.1366 168.72)",
    "600": "oklch(44.52% 0.11251 174.16)",
    "700": "oklch(35.02% 0.086974 175.96)",
    "800": "oklch(30.41% 0.065411 177.79)",
    "900": "oklch(24.34% 0.05243 178.3)",
    "950": "oklch(21.67% 0.036277 177.12)",
    "975": "oklch(20.2% 0.026719 175.51)"
  },
  "teal": {
    "25": "oklch(97.72% 0.029235 195.48)",
    "50": "oklch(95.09% 0.051172 193.03)",
    "100": "oklch(90.27% 0.092659 194.54)",
    "200": "oklch(84.85% 0.116142 192.62)",
    "300": "oklch(74.31% 0.139418 191.63)",
    "400": "oklch(60.61% 0.140155 191.78)",
    "500": "oklch(51.5% 0.11539 191.5)",
    "600": "oklch(45.08% 0.094064 195.52)",
    "700": "oklch(35.49% 0.077424 197.45)",
    "800": "oklch(30.42% 0.058548 203.16)",
    "900": "oklch(24.75% 0.043038 204.79)",
    "950": "oklch(22.25% 0.042638 208.95)",
    "975": "oklch(20.11% 0.027985 216.65)"
  },
  "cyan": {
    "25": "oklch(97.43% 0.020231 213.43)",
    "50": "oklch(94.99% 0.0435 218.94)",
    "100": "oklch(90.17% 0.08534 209.25)",
    "200": "oklch(85.49% 0.111487 210.69)",
    "300": "oklch(75.58% 0.138354 216.54)",
    "400": "oklch(61.42% 0.148157 219.92)",
    "500": "oklch(51.81% 0.140797 225.99)",
    "600": "oklch(44.76% 0.11516 229.23)",
    "700": "oklch(36.18% 0.091277 235.32)",
    "800": "oklch(30.79% 0.073262 232.54)",
    "900": "oklch(24.76% 0.051925 237.49)",
    "950": "oklch(22.32% 0.044985 238.87)",
    "975": "oklch(20.57% 0.031083 239.08)"
  },
  "blue": {
    "25": "oklch(96.84% 0.021755 234.34)",
    "50": "oklch(95.04% 0.030209 235.63)",
    "100": "oklch(90.57% 0.059432 236.89)",
    "200": "oklch(86.24% 0.09584 244.04)",
    "300": "oklch(76.11% 0.1391 253.27)",
    "400": "oklch(62.43% 0.2137 257.42)",
    "500": "oklch(53.57% 0.2336 258.19)",
    "600": "oklch(46.82% 0.206355 259.87)",
    "700": "oklch(37.19% 0.176608 260.1)",
    "800": "oklch(31.35% 0.124931 257.45)",
    "900": "oklch(24.84% 0.075028 254.77)",
    "950": "oklch(22.49% 0.052249 253.4)",
    "975": "oklch(20.86% 0.033268 252.39)"
  },
  "navy": {
    "25": "oklch(97.3% 0.015 255.55)",
    "50": "oklch(95% 0.03 254.77)",
    "100": "oklch(90.78% 0.05 250.69)",
    "200": "oklch(86.44% 0.078 253.13)",
    "300": "oklch(77% 0.145 258.64)",
    "400": "oklch(63% 0.1723 259.89)",
    "500": "oklch(54.45% 0.1908 263.29)",
    "600": "oklch(47.02% 0.1818 264.73)",
    "700": "oklch(38% 0.139595 263.6736)",
    "800": "oklch(30.97% 0.11 261.79)",
    "900": "oklch(24.98% 0.0739 263.05)",
    "950": "oklch(22.5% 0.057 265.89)",
    "975": "oklch(21% 0.04 265.94)"
  },
  "indigo": {
    "25": "oklch(97.16% 0.014798 275.61)",
    "50": "oklch(95.2% 0.02669 277.11)",
    "100": "oklch(90.46% 0.049495 277.42)",
    "200": "oklch(87.16% 0.068886 273.41)",
    "300": "oklch(76.41% 0.125676 272.25)",
    "400": "oklch(64.09% 0.193109 273.76)",
    "500": "oklch(54.62% 0.192017 274.39)",
    "600": "oklch(48.65% 0.191201 276.76)",
    "700": "oklch(38.3% 0.1507 278.31)",
    "800": "oklch(31.09% 0.1034 278.54)",
    "900": "oklch(25.69% 0.077869 278.11)",
    "950": "oklch(23.32% 0.071725 277.84)",
    "975": "oklch(21.31% 0.052096 278.86)"
  },
  "violet": {
    "25": "oklch(97.52% 0.011867 286.18)",
    "50": "oklch(95.46% 0.024824 285.92)",
    "100": "oklch(91.54% 0.047287 287.09)",
    "200": "oklch(87.12% 0.071798 283.99)",
    "300": "oklch(77.68% 0.126442 283.7)",
    "400": "oklch(64.89% 0.206822 282.12)",
    "500": "oklch(56.86% 0.282911 282.04)",
    "600": "oklch(49.92% 0.262957 283.33)",
    "700": "oklch(39.89% 0.21477 282.01)",
    "800": "oklch(32.93% 0.153898 280.88)",
    "900": "oklch(25.55% 0.086271 281.55)",
    "950": "oklch(23.01% 0.07165 283.17)",
    "975": "oklch(20.89% 0.063368 284.41)"
  },
  "purple": {
    "25": "oklch(97.8% 0.01273 307.36)",
    "50": "oklch(95.37% 0.032452 309.43)",
    "100": "oklch(92.52% 0.05278 309.19)",
    "200": "oklch(87.78% 0.083919 306.27)",
    "300": "oklch(79.03% 0.146188 305.14)",
    "400": "oklch(66.36% 0.235214 302.03)",
    "500": "oklch(56.24% 0.2825 298.91)",
    "600": "oklch(51.4% 0.27522 297.94)",
    "700": "oklch(39.44% 0.185546 295.19)",
    "800": "oklch(34.04% 0.13832 296.08)",
    "900": "oklch(26.75% 0.102901 298.02)",
    "950": "oklch(22.98% 0.084969 297.63)",
    "975": "oklch(20.42% 0.064488 296.18)"
  },
  "magenta": {
    "25": "oklch(97.97% 0.018492 322.88)",
    "50": "oklch(95.5% 0.040564 323.35)",
    "100": "oklch(92.73% 0.069297 326.92)",
    "200": "oklch(88.37% 0.103494 323.71)",
    "300": "oklch(79.34% 0.193658 325.47)",
    "400": "oklch(68.65% 0.312754 324.15)",
    "500": "oklch(58.8% 0.288057 325.56)",
    "600": "oklch(49.96% 0.234427 325.83)",
    "700": "oklch(39.93% 0.179746 322.16)",
    "800": "oklch(33.55% 0.1358 325.86)",
    "900": "oklch(25.51% 0.093576 328.91)",
    "950": "oklch(22.93% 0.073158 333.37)",
    "975": "oklch(20.14% 0.051172 336.99)"
  },
  "pink": {
    "25": "oklch(97.82% 0.022 339.73)",
    "50": "oklch(95.47% 0.035064 338.37)",
    "100": "oklch(92.21% 0.073347 338.84)",
    "200": "oklch(88.7% 0.103251 342.55)",
    "300": "oklch(78.23% 0.195486 348.86)",
    "400": "oklch(68.08% 0.295542 353.62)",
    "500": "oklch(57.93% 0.256121 354.31)",
    "600": "oklch(49.96% 0.216267 356.14)",
    "700": "oklch(39.33% 0.174755 353.09)",
    "800": "oklch(33.94% 0.141093 352.69)",
    "900": "oklch(26.76% 0.101872 353.19)",
    "950": "oklch(23.17% 0.082689 354.41)",
    "975": "oklch(19.9% 0.047189 350.36)"
  },
  "blackOpaque": {
    "25": "oklch(98.51% 0 0)",
    "50": "oklch(96.72% 0 0)",
    "75": "oklch(94.41% 0 0)",
    "100": "oklch(92.8% 0 0)",
    "200": "oklch(88.53% 0 0)",
    "300": "oklch(77.31% 0 0)",
    "400": "oklch(61.67% 0 0)",
    "500": "oklch(52.08% 0 0)",
    "600": "oklch(44.95% 0 0)",
    "700": "oklch(30.08% 0 0)",
    "800": "oklch(25.2% 0 0)",
    "900": "oklch(21.78% 0 0)",
    "950": "oklch(19.02% 0 0)",
    "975": "oklch(17.38% 0 0)",
    "1000": "#0b0b0b"
  },
  "blackAlpha": {
    "25": "oklch(0% 0 0 / 0.015)",
    "50": "oklch(0% 0 0 / 0.033)",
    "75": "oklch(0% 0 0 / 0.06)",
    "100": "oklch(0% 0 0 / 0.09)",
    "200": "oklch(0% 0 0 / 0.15)",
    "300": "oklch(0% 0 0 / 0.29)",
    "400": "oklch(0% 0 0 / 0.44)",
    "500": "oklch(0% 0 0 / 0.59)",
    "600": "oklch(0% 0 0 / 0.67)",
    "700": "oklch(0% 0 0 / 0.82)",
    "800": "oklch(0% 0 0 / 0.87)",
    "900": "oklch(0% 0 0 / 0.9)",
    "950": "oklch(0% 0 0 / 0.92)",
    "975": "oklch(0% 0 0 / 0.94)"
  },
  "whiteAlpha": {
    "25": "oklch(1 0 0 / 0.022)",
    "50": "oklch(1 0 0 / 0.044)",
    "75": "oklch(1 0 0 / 0.067)",
    "100": "oklch(1 0 0 / 0.09)",
    "200": "oklch(1 0 0 / 0.16)",
    "300": "oklch(1 0 0 / 0.36)",
    "400": "oklch(1 0 0 / 0.52)",
    "500": "oklch(1 0 0 / 0.59)",
    "600": "oklch(1 0 0 / 0.72)",
    "700": "oklch(1 0 0 / 0.83)",
    "800": "oklch(1 0 0 / 0.87)",
    "900": "oklch(1 0 0 / 0.91)",
    "950": "oklch(1 0 0 / 0.94)",
    "975": "oklch(1 0 0 / 0.97)"
  },
  "gray": {
    "25": "oklch(98.64% 0.00261 235.54)",
    "50": "oklch(96.8% 0.00296 239.39)",
    "75": "oklch(95.05% 0.005962 243.25)",
    "100": "oklch(92.8% 0.00883 248.94)",
    "200": "oklch(87.9% 0.015703 248.93)",
    "300": "oklch(78.61% 0.024126 247.06)",
    "400": "oklch(61.61% 0.023605 248.41)",
    "500": "oklch(51.86% 0.022431 248.9)",
    "600": "oklch(44.93% 0.021873 249.5)",
    "700": "oklch(31.43% 0.018726 251.19)",
    "800": "oklch(25.52% 0.014768 245.21)",
    "900": "oklch(22.43% 0.014978 239.01)",
    "950": "oklch(20.27% 0.012572 237.68)",
    "975": "oklch(18.89% 0.01042 235.21)"
  },
  "grayAlpha": {
    "25": "oklch(0.45 0.07 250.24 / 0.03)",
    "50": "oklch(0.51 0.06 246.6 / 0.07)",
    "75": "oklch(0.49 0.04 247.11 / 0.1)",
    "100": "oklch(0.46 0.06 240.06 / 0.14)",
    "200": "oklch(0.43 0.04 242.8 / 0.19)",
    "300": "oklch(0.49 0.05 239.95 / 0.43)",
    "400": "oklch(0.42 0.04 251.36 / 0.66)",
    "500": "oklch(0.41 0.03 244.38 / 0.83)",
    "600": "oklch(0.36 0.02 250.95 / 0.85)",
    "700": "oklch(0.13 0.03 240.55 / 0.84)",
    "800": "oklch(0.12 0.03 246.75 / 0.89)",
    "900": "oklch(0.11 0.02 229.57 / 0.91)",
    "950": "oklch(0.12 0.02 230.8 / 0.93)",
    "975": "oklch(0.11 0.02 224.36 / 0.95)"
  },
  "zinc": {
    "25": "oklch(98.44% 0.002449 286.37)",
    "50": "oklch(97.41% 0.004361 286.32)",
    "75": "oklch(94.47% 0.007327 286.26)",
    "100": "oklch(92.59% 0.004417 286.31)",
    "200": "oklch(88.69% 0.007444 286.25)",
    "300": "oklch(78.51% 0.015423 280.74)",
    "400": "oklch(61.4% 0.026343 279.01)",
    "500": "oklch(52.16% 0.027448 278.83)",
    "600": "oklch(45% 0.026729 278.28)",
    "700": "oklch(31.12% 0.013689 278.07)",
    "800": "oklch(25.01% 0.010229 285.64)",
    "900": "oklch(22.45% 0.010509 285.52)",
    "950": "oklch(19.08% 0.010766 284.95)",
    "975": "oklch(17.57% 0.01117 285.19)"
  },
  "ash": {
    "25": "oklch(98.42% 0.001186 195.88)",
    "50": "oklch(97.18% 0.00557 201.42)",
    "75": "oklch(94.64% 0.005982 208.01)",
    "100": "oklch(93.26% 0.003088 224.28)",
    "200": "oklch(88.45% 0.005237 254.44)",
    "300": "oklch(77.23% 0.005418 254.44)",
    "400": "oklch(61.3% 0.01229 264.4)",
    "500": "oklch(51.98% 0.018756 261.08)",
    "600": "oklch(44.49% 0.019508 261.01)",
    "700": "oklch(31.35% 0.01639 266.49)",
    "800": "oklch(24.77% 0.019974 263.02)",
    "900": "oklch(22.1% 0.016685 257.78)",
    "950": "oklch(20.36% 0.017027 257.71)",
    "975": "oklch(16.8% 0.014935 260.56)"
  },
  "sage": {
    "25": "oklch(98.55% 0.005963 149.04)",
    "50": "oklch(97.17% 0.007319 159)",
    "75": "oklch(94.58% 0.010086 160.28)",
    "100": "oklch(92.71% 0.008956 156.09)",
    "200": "oklch(88.12% 0.009781 172.49)",
    "300": "oklch(77.49% 0.016853 174.17)",
    "400": "oklch(61.53% 0.017813 174.02)",
    "500": "oklch(51.37% 0.016527 177.41)",
    "600": "oklch(44.55% 0.011955 178.32)",
    "700": "oklch(29.98% 0.012389 170.18)",
    "800": "oklch(25.13% 0.012683 177.82)",
    "900": "oklch(22.19% 0.014791 169.91)",
    "950": "oklch(20.39% 0.013319 166.55)",
    "975": "oklch(17.03% 0.018154 167.98)"
  },
  "sand": {
    "25": "oklch(98.48% 0.001449 106.43)",
    "50": "oklch(97.39% 0.005107 74.48)",
    "75": "oklch(94.72% 0.00398 73.24)",
    "100": "oklch(93.21% 0.008372 77.16)",
    "200": "oklch(87.5% 0.009259 69.58)",
    "300": "oklch(78.39% 0.013546 58.75)",
    "400": "oklch(62.1% 0.005713 54.49)",
    "500": "oklch(51.89% 0.008251 71.36)",
    "600": "oklch(44.34% 0.003995 63.23)",
    "700": "oklch(30.83% 0.005539 63.17)",
    "800": "oklch(25.81% 0.002747 63.23)",
    "900": "oklch(22.18% 0.007477 103.89)",
    "950": "oklch(20.33% 0.006421 106.96)",
    "975": "oklch(17.48% 0.015305 107.88)"
  },
  "plum": {
    "25": "oklch(98.65% 0.006418 333.22)",
    "50": "oklch(97.23% 0.006083 343.36)",
    "75": "oklch(95.02% 0.006204 347.87)",
    "100": "oklch(93.2% 0.006234 347.87)",
    "200": "oklch(88.17% 0.009177 335.53)",
    "300": "oklch(77.22% 0.015965 335.69)",
    "400": "oklch(61.61% 0.014685 342.53)",
    "500": "oklch(52.59% 0.020549 343.12)",
    "600": "oklch(45.31% 0.02193 342.41)",
    "700": "oklch(30.71% 0.009306 337.59)",
    "800": "oklch(24.56% 0.009837 337.71)",
    "900": "oklch(21.99% 0.010109 337.78)",
    "950": "oklch(19.64% 0.011482 336.2)",
    "975": "oklch(16.94% 0.010493 329.66)"
  },
  "steel": {
    "25": "oklch(98.47% 0.004827 235)",
    "50": "oklch(97.24% 0.012483 250.79)",
    "75": "oklch(94.92% 0.016784 240.54)",
    "100": "oklch(93.57% 0.021809 244.17)",
    "200": "oklch(88.37% 0.03258 246.44)",
    "300": "oklch(78.22% 0.042734 251.2)",
    "400": "oklch(61.45% 0.053767 253.63)",
    "500": "oklch(51.87% 0.061841 255.54)",
    "600": "oklch(44.74% 0.055776 257.38)",
    "700": "oklch(30.53% 0.043334 258.07)",
    "800": "oklch(25.24% 0.029371 258.77)",
    "900": "oklch(21.19% 0.021637 255.58)",
    "950": "oklch(19.42% 0.018964 260.52)",
    "975": "oklch(17.12% 0.012659 256.69)"
  }
};